const BASE = `${process.env.REACT_APP_API_URL_LOCAL}/api/images`;

export const IMAGE_UPLOAD_URL = `${BASE}/upload`;
